import { Fragment } from 'react'
import Image from 'next/image'

import Navbar from 'components/navbar'
import Layout, { Textlayout } from 'components/layout'
import * as Portfoliorawcmp from 'components/portfolio/allItem'
import Pagetitle from 'components/pageTitle'
import Footer from 'components/footer'
import Seo from 'components/seo'
import LogoSlider from 'components/portfolio/logoSlider'

import { portfolioHomeData, pageData } from 'data/portfolio/index'
import classNames from 'classnames'
import Link from 'next/link'

export default function portfolioIndex() {
  return (
    <>
      <Seo
        title="Portfolio"
        description="Découvrez les différents projets sur lesquels l'Atelier Milky a déjà eu l'occasion de travailler."
        canonical={`/portfolio`}
      />
      <div className="overflow-hidden">
        <Navbar />
        <main className="relative mt-12 md:mt-24">
          <Layout>
            <Pagetitle>Portfolio</Pagetitle>

            <div className="mt-8">
              <Textlayout>
                <div className="space-y-4 text-justify text-lg leading-tight">{pageData.intro}</div>
              </Textlayout>
            </div>

            <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2">
              {portfolioHomeData.map((thisPortfolio, index) => {
                const InnerElementsFirsts = [
                  <div id={thisPortfolio.slug} className={classNames({ 'md:-mt-40': index % 3 !== 0 })}>
                    <Link href={`/portfolio/${thisPortfolio.slug}`}>
                      <a>
                        <Image
                          src={thisPortfolio.image.url}
                          className={`h-auto w-full`}
                          width={thisPortfolio.image.width}
                          height={thisPortfolio.image.height}
                        />
                      </a>
                    </Link>
                  </div>,
                  <Link href={`/portfolio/${thisPortfolio.slug}`}>
                    <a className={classNames({ 'flex flex-col items-end justify-end': index % 2 })}>
                      <PortfolioPlus className="mb-4" />
                      <PortfolioTitle className={classNames({ 'text-right': index % 2 })}>
                        {thisPortfolio.name}
                      </PortfolioTitle>
                      <PortfolioServices services={thisPortfolio.types} />
                    </a>
                  </Link>
                ]

                if ([0, 1].indexOf(index) !== -1) {
                  return (
                    <Fragment key={thisPortfolio.id}>
                      {index % 2 ? InnerElementsFirsts.reverse() : InnerElementsFirsts}
                    </Fragment>
                  )
                }

                return (
                  <Fragment key={thisPortfolio.id}>
                    {
                      [
                        <Fragment key={thisPortfolio.id + '-1'}>
                          <div id={thisPortfolio.slug} className="md:col-span-2">
                            <Link href={`/portfolio/${thisPortfolio.slug}`}>
                              <a>
                                <Image
                                  src={thisPortfolio.image.url}
                                  className={`h-auto w-full`}
                                  width={thisPortfolio.image.width}
                                  height={thisPortfolio.image.height}
                                />
                              </a>
                            </Link>
                          </div>
                          <Link href={`/portfolio/${thisPortfolio.slug}`}>
                            <a>
                              <PortfolioPlus className="mb-4" />
                              <PortfolioTitle className="text-left md:pr-24">{thisPortfolio.name}</PortfolioTitle>
                              <PortfolioServices services={thisPortfolio.types} />
                            </a>
                          </Link>
                        </Fragment>,
                        <div id={thisPortfolio.slug} className="space-y-4" key={thisPortfolio.id + '-2'}>
                          <div>
                            <Link href={`/portfolio/${thisPortfolio.slug}`}>
                              <a>
                                <Image
                                  src={thisPortfolio.image.url}
                                  className={`h-auto w-full`}
                                  width={thisPortfolio.image.width}
                                  height={thisPortfolio.image.height}
                                />
                              </a>
                            </Link>
                          </div>
                          <Link href={`/portfolio/${thisPortfolio.slug}`}>
                            <a className="mt-4 flex flex-col items-end">
                              <PortfolioPlus className="mb-4" />
                              <PortfolioTitle className="text-right md:pl-24">{thisPortfolio.name}</PortfolioTitle>
                              <PortfolioServices services={thisPortfolio.types} />
                            </a>
                          </Link>
                        </div>,
                        <Fragment key={thisPortfolio.id + '-3'}>
                          <div id={thisPortfolio.slug} className="md:-mt-32">
                            <Link href={`/portfolio/${thisPortfolio.slug}`}>
                              <a>
                                <Image
                                  src={thisPortfolio.image.url}
                                  className={`h-auto w-full`}
                                  width={thisPortfolio.image.width}
                                  height={thisPortfolio.image.height}
                                />
                              </a>
                            </Link>
                          </div>
                          <Link href={`/portfolio/${thisPortfolio.slug}`}>
                            <a className="flex h-full flex-col items-start justify-end">
                              <PortfolioPlus className="mb-4" />
                              <PortfolioTitle className="md:pr-24 lg:pr-40">{thisPortfolio.name}</PortfolioTitle>
                              <PortfolioServices services={thisPortfolio.types} />
                            </a>
                          </Link>
                        </Fragment>
                      ][(index + 1) % 3]
                    }
                  </Fragment>
                )
              })}
            </div>
            <div>
              <h2 className="mt-12 text-center text-2xl font-semibold text-yellow md:text-3xl">
                Ils nous font aussi confiance
              </h2>

              <LogoSlider className="mt-8" />
            </div>
          </Layout>
        </main>
        <div className="mt-32">
          <Footer />
        </div>
      </div>
    </>
  )
}

const PortfolioTitle = ({ className, children }) => (
  <h2 className={classNames('font-serif text-5xl font-bold leading-[4.5rem] md:text-6xl', className)}>{children}</h2>
)

const PortfolioServices = ({ className, services }) => {
  return (
    <ul className={classNames(className, 'space-y-2')}>
      {services.map((thisService) => (
        <li key={thisService} className="text-lg font-light uppercase">
          {thisService}
        </li>
      ))}
    </ul>
  )
}

const PortfolioPlus = ({ className }) => (
  <div className={classNames(className, 'inline-block rounded-full border-[1.5px] border-orange p-4 text-orange')}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 34 34"
      className="h-8 w-8 transform transition-transform"
      stroke="currentColor">
      <path strokeWidth={2} d="M32 17H17M17 17H2M17 17V2M17 17V32.5" />
    </svg>
  </div>
)
